import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import { Row, Col } from '../../framework/Grid'

class SaveSuccess extends Component {
	componentDidMount(){
		this.props.clearSegmentWithRules();
	}
	render() {
		return (
			<div className="mt-20">
				<Row className="no-margin-bottom">
					<Col xs="5" sm="5" md="5" lg="5" offsetXs="4" offsetSm="4" offsetMd="4" offsetLg="4">
						<h3><bold>Your audience segment has been saved!</bold></h3>
					</Col>
				</Row>
				<Row className="no-margin-top no-padding-top no-margin-bottom font-12em">
					<Col xs="7" sm="7" md="7" lg="7" offsetXs="4" offsetSm="4" offsetMd="4" offsetLg="4">
						<span className="pr-10" style={{display:"table-cell"}}><i className="icon-checkmark4 text-teal-400 " /></span>
						<span style={{display:"table-cell"}}>
							{this.props.segment_name} has been added to your <Link to="/segments/list/active">audience segment list </Link>
						</span>
					</Col>
				</Row>
				<Row className="no-margin-top no-padding-top no-margin-bottom font-12em">
					<Col xs="7" sm="7" md="7" lg="7" offsetXs="4" offsetSm="4" offsetMd="4" offsetLg="4">
						<span className="mr-10"><i className="icon-checkmark4 text-teal-400 " /></span>View atttribute breakdown in your <a href={"/segments/list/detail/" + this.props.save_segment_report_id}>audience segment report </a>
					</Col>
				</Row>
				<Row className="font-12em">
					<Col xs="7" sm="7" md="7" lg="7" offsetXs="4" offsetSm="4" offsetMd="4" offsetLg="4">
						{/*<span className="mr-10"><i className="icon-redo " /></span>*/}
						{/*<a href="#">Apply this audience segment to a new campaign</a>*/}
						<div style={{width:'100%', paddingLeft: "25px"}}>
							<button type="button" className="btn btn-default legitRipple bg-teal-400">
								<Link to="/segment/create" style={{color: '#FFF'}}>Create an Audience Segment</Link>
							</button>
						</div>
					</Col>
				</Row>
			</div>
		)
	}
}

export default SaveSuccess


// WEBPACK FOOTER //
// ./src/components/Segment/SaveSuccess/index.js